type BestForLabelProps = {
  label: string;
};

export default function BestForLabel({ label }: BestForLabelProps) {
  return (
    <span className="inline-block rounded-full bg-[hsl(210_53%_23%)] text-white px-2.5 py-0.5 text-[11px] font-body leading-tight whitespace-nowrap">
      {label}
    </span>
  );
}

/** Predefined provider labels */
export const PROVIDER_LABELS: Record<string, string[]> = {
  Tabby: ["Fastest approval", "Best for travel"],
  Tamara: ["Sharia compliant", "Best for families"],
  Cashew: ["Longest terms", "Best for healthcare"],
  Zendi: ["Best for education", "School fee specialist"],
  Skiply: ["Best for education", "No credit check"],
};
